module.exports = __webpack_public_path__ + "0397055766473ee9d830495d2f013580.png";